<template>
    <div class="box">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <div style="overflow-x: auto;overflow-y: hidden;display: flex;align-items: center;">
                <recursive-menu :menu-list="classifyList" style="display: flex;align-items: center;"></recursive-menu>
            </div>
        </el-menu>
        <div>
            <button></button>
        </div>
        <ul class="imgUrl" v-if="urlList.length > 0">
            <li v-for="(item, index) in urlList" :key="index" @click="detailsClick(item)">
                <img style="width: 228px;height: 203px;display: block;" :src="`${imgUrl}/${item.imgUrl}`" alt="" />
                <div class="content">
                    <p>{{ item.imgTitle }}</p>
                </div>
            </li>
        </ul>
        <div v-else>
            <el-empty :image-size="200"></el-empty>
        </div>
    </div>
</template>

<script>
import recursiveMenu from "./components/recursiveMenu.vue";
export default {
    name: "homePage",
    components: {
        recursiveMenu
    },
    data() {
        return {
            urlList: "",
            activeIndex: "",
            imgUrl: "",
            classifyList: [],
            returnData: {
                list: []
            }
        }
    },
    created() {

    },
    methods: {
        openBox(val) {
            console.log(val);

            if (val) {
                this.imgUrl = window.global_config.BASE_IMG_URL
                this.slideshowQuery(val.classId)
            }
            this.queryClassify()
        },
        async queryClassify() {
            let responseData = await this.$http.carouseClassifyqueryList({})
            if (responseData.status == 200) {
                this.returnData.list = responseData.result
                this.classifyList = this.handleJurisdiction(responseData.result)
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    value['id'] = value['id']
                    value['value'] = `${lev}-${value['id']}`
                    value['label'] = value['className']
                    value['contentUrl'] = value['contentUrl']
                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    }
                    son.push(value)

                }
            })
            return son;
        },
        handleSelect(val) {
            var str = val.split('-')[1]
            window.scrollTo(0, 0)
            this.slideshowQuery(str)
        },
        async slideshowQuery(str) {
            const res = await this.$http.carouselqueryList({ classId: str })
            if (res.status == 200) {
                if (res.result.length > 0) {
                    this.urlList = res.result
                } else {
                    this.urlList = []
                }
            }
        },
        detailsClick(item) {
            this.$emit('paramToHome', '/homePageDetails', true, {
                item: item
            })
        },
    }
}
</script>

<style scoped>
.box {
    width: 100%;
    height: 100%;
    background-color: rgb(248, 248, 248);
    overflow: auto;
    display: flex;
    justify-content: center;
    padding-top: 50px;
}

.el-menu-demo {
    position: fixed;
    top: 70px;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 calc((100vw - 1200px) / 2);
}

.imgUrl {
    width: 1200px;
    font-size: 0;
}

.imgUrl li {
    width: 228px;
    margin-top: 15px;
    margin-right: 15px;
    display: inline-block;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    cursor: pointer;
}

.imgUrl li:nth-child(5n) {
    margin-right: 0;
}

.content p {
    font-size: 18px;
    color: #333;
    font-weight: 700;
    padding: 10px;
}

::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title,
::v-deep .el-menu--horizontal>.el-menu-item {
    height: 50px;
    line-height: 50px;
}

::v-deep .el-submenu__icon-arrow {
    position: static !important;
    vertical-align: middle !important;
    margin-left: 8px !important;
    margin-top: -3px !important;
}
</style>